export default {
  // Button text
  historyList: "History List",
  keyStep: "Key Steps",

  // Titles
  keyStepTitle: "Key Steps",
  historyListTitle: "History List",
};
